export default __webpack_public_path__ + "static/media/history.a346545a.svg";